import { power_supply } from './power_supply';

import { ID_GRAPH_AXIS } from '../../constants/idDefinition';
import { CHART_TYPE, SIMULATION_TYPE, UNITS_SIGN } from '../../constants/definitionConstants';

export class ncv59745amw100tag extends power_supply {
	constructor(opn) {
		super(opn, 'ncv59745');
		this.PACKAGE_IMAGE = require(`../../images/QFNW20_CASE_484AP.png`);
		this.SCHEMATIC_DC = require(`../../images/${this.opn}_SCH_DC.svg`);
		this.SCHEMATIC_TRAN = require(`../../images/${this.opn}_SCH_TRAN.svg`);
		this.modelLink = '';
	}

	gainDefinition() {
		const DC_CHART_COLUMN_MAPPING = {
			V_PG: 7
		};
		const TRANSIENT_CHART_COLUMN_MAPPING = {
			TIME: 0,
			TEMP: 1,
			R_LOAD: 2,
			V_IN: 3,
			V_PG: 4,
			V_EN: 5,
			V_OUT: 6,
			V_BIAS: 7,
			I_OUT: 8,
			I_GND: 9
		};
		const customizations = {
			simulations: [
				{
					showInputParams: false,
					inputParameters: [
						{
							/**
							 * base heading (heading is created from heading + unit)
							 */
							heading: 'V<sub>IN<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							/**
							 * if unit is not base unit but for example it is in kilo ohm it is needed
							 * to add extension for simulator which tells that it is kilo that’s mean ‘k’
							 */
							netlistUnit: '',
							/**
							 * exact name of parameter from netlist to be replaced
							 */
							mappingName: 'V_INmin',
							minBoundary: 0.1,
							maxBoundary: 1.65,
							defaultValue: 0.1
						},
						{
							heading: 'V<sub>IN<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_INmax',
							minBoundary: 0.2,
							maxBoundary: 1.7,
							defaultValue: 1.5
						},
						{
							heading: 'V<sub>IN<sub>(increment)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_INstep',
							minBoundary: 0.01,
							maxBoundary: 1,
							defaultValue: 0.1
						},
						{
							heading: 'R<sub>OUT<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.OHM,
							netlistUnit: '',
							mappingName: 'loadMin',
							minBoundary: 0.42,
							maxBoundary: 100,
							defaultValue: 0.5
						},
						{
							heading: 'R<sub>OUT<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.OHM,
							netlistUnit: '',
							mappingName: 'loadMax',
							minBoundary: 0.45,
							maxBoundary: 100,
							defaultValue: 2
						},
						{
							heading: 'R<sub>OUT<sub>(num.steps)</sub></sub>',
							unit: UNITS_SIGN.NOUNITS,
							netlistUnit: '',
							mappingName: 'nLoadSteps',
							minBoundary: 1,
							maxBoundary: 25,
							defaultValue: 4,
							isInteger: true
						},
						{
							heading: 'V<sub>BIAS<sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_BIAS',
							minBoundary: 0.1,
							maxBoundary: 5.5,
							defaultValue: 2.7
						},
						{
							heading: 't<sub>ambient<sub>',
							unit: UNITS_SIGN.CELSIUS,
							netlistUnit: '',
							mappingName: 'Tset',
							minBoundary: -40,
							maxBoundary: 125,
							defaultValue: 25,
							displayInput: true
						}
					],
					schematic: {
						schematicPath: this.SCHEMATIC_DC
					},
					charts: [
						{},
						{},
						{},
						{},
						{},
						{
							/**
							 * --------------------------------------------------- V_PG vs V_IN ---------------------------------------------------
							 */
							id: 'VpgVsVin',
							mainHeading:
								'V[baseline-shift: sub; font-size: 11px;]PG[/] = f (V[baseline-shift: sub; font-size: 11px;]IN[/], R[baseline-shift: sub; font-size: 11px;]OUT[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.DC,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'V[baseline-shift: sub; font-size: 11px;]IN[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: this.DC_CHART_COLUMN_MAPPING.V_IN
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]PG[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: DC_CHART_COLUMN_MAPPING.V_PG
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: this.DC_CHART_COLUMN_MAPPING.R_LOAD
							}
						}
					]
				},
				{
					showInputParams: false,
					inputParameters: [
						{
							heading: 'V<sub>IN<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_INmin',
							minBoundary: 0.1,
							maxBoundary: 1.65,
							defaultValue: 0.1
						},
						{
							heading: 'V<sub>IN<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_INmax',
							minBoundary: 0.2,
							maxBoundary: 1.7,
							defaultValue: 1.5
						},
						{
							heading: 't<sub>rise<sub>V<sub>IN</sub></sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'V_INtr',
							minBoundary: 1,
							maxBoundary: 500,
							defaultValue: 100
						},
						{
							heading: 't<sub>fall<sub>V<sub>IN</sub></sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'V_INtf',
							minBoundary: 1,
							maxBoundary: 500,
							defaultValue: 100
						},
						{
							heading: 't<sub>ON<sub>V<sub>IN</sub></sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'V_INtON',
							minBoundary: 1,
							maxBoundary: 500,
							defaultValue: 300
						},
						{
							heading: 'V<sub>EN<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_ENmin',
							minBoundary: 0,
							maxBoundary: 5.4,
							defaultValue: 0
						},
						{
							heading: 'V<sub>EN<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_ENmax',
							minBoundary: 0.1,
							maxBoundary: 5.5,
							defaultValue: 5
						},
						{
							heading: 't<sub>EN<sub>delay</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'ENtDelay',
							minBoundary: 1,
							maxBoundary: 500,
							defaultValue: 50
						},
						{
							heading: 't<sub>EN<sub>rise</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'ENtr',
							minBoundary: 1,
							maxBoundary: 500,
							defaultValue: 100
						},
						{
							heading: 't<sub>EN<sub>ON</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'ENtON',
							minBoundary: 1,
							maxBoundary: 500,
							defaultValue: 200
						},
						{
							heading: 't<sub>EN<sub>fall</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'ENtf',
							minBoundary: 1,
							maxBoundary: 500,
							defaultValue: 100
						},
						{
							heading: 'V<sub>BIAS<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_BIASmin',
							minBoundary: 0,
							maxBoundary: 5.4,
							defaultValue: 0
						},
						{
							heading: 'V<sub>BIAS<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'V_BIASmax',
							minBoundary: 0.1,
							maxBoundary: 5.5,
							defaultValue: 2.7
						},
						{
							heading: 't<sub>BIAS<sub>delay</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'BIAStDelay',
							minBoundary: 1,
							maxBoundary: 500,
							defaultValue: 100
						},
						{
							heading: 't<sub>BIAS<sub>rise</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'BIAStr',
							minBoundary: 1,
							maxBoundary: 500,
							defaultValue: 100
						},
						{
							heading: 't<sub>BIAS<sub>ON</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'BIAStON',
							minBoundary: 1,
							maxBoundary: 500,
							defaultValue: 100
						},
						{
							heading: 't<sub>BIAS<sub>fall</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'BIAStf',
							minBoundary: 1,
							maxBoundary: 500,
							defaultValue: 100
						},
						{
							heading: 't<sub>step<sub>max</sub></sub>',
							unit: UNITS_SIGN.MILLI_SECOND,
							netlistUnit: 'm',
							mappingName: 'Tstep',
							minBoundary: 1,
							maxBoundary: 100,
							defaultValue: 10
						},
						{
							heading: 'R<sub>OUT<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.OHM,
							netlistUnit: '',
							mappingName: 'loadMin',
							minBoundary: 0.42,
							maxBoundary: 100,
							defaultValue: 0.5
						},
						{
							heading: 'R<sub>OUT<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.OHM,
							netlistUnit: '',
							mappingName: 'loadMax',
							minBoundary: 0.45,
							maxBoundary: 100,
							defaultValue: 2
						},
						{
							heading: 'R<sub>OUT<sub>(num.steps)</sub></sub>',
							unit: UNITS_SIGN.NOUNITS,
							netlistUnit: '',
							mappingName: 'nLoadSteps',
							minBoundary: 1,
							maxBoundary: 6,
							defaultValue: 4,
							isInteger: true
						},
						{
							heading: 'C<sub>IN</sub>',
							unit: UNITS_SIGN.MICRO_FARAD,
							netlistUnit: 'u',
							mappingName: 'Cin',
							minBoundary: 4.7,
							maxBoundary: 1000,
							defaultValue: 4.7
						},
						{
							heading: 'ESR<sub>C<sub>IN</sub></sub>',
							unit: UNITS_SIGN.MILLI_OHM,
							netlistUnit: 'm',
							mappingName: 'EsrCin',
							minBoundary: 0,
							maxBoundary: 1000,
							defaultValue: 1
						},
						{
							heading: 'C<sub>OUT</sub>',
							unit: UNITS_SIGN.MICRO_FARAD,
							netlistUnit: 'u',
							mappingName: 'Cout',
							minBoundary: 10,
							maxBoundary: 1000,
							defaultValue: 10
						},
						{
							heading: 'ESR<sub>C<sub>OUT</sub></sub>',
							unit: UNITS_SIGN.MILLI_OHM,
							netlistUnit: 'm',
							mappingName: 'EsrCout',
							minBoundary: 0,
							maxBoundary: 1000,
							defaultValue: 1
						},
						{
							heading: 'C<sub>BIAS</sub>',
							unit: UNITS_SIGN.MICRO_FARAD,
							netlistUnit: 'u',
							mappingName: 'Cbias',
							minBoundary: 1,
							maxBoundary: 1000,
							defaultValue: 1
						},
						{
							heading: 'ESR<sub>C<sub>BIAS</sub></sub>',
							unit: UNITS_SIGN.MILLI_OHM,
							netlistUnit: 'm',
							mappingName: 'EsrCbias',
							minBoundary: 0,
							maxBoundary: 1000,
							defaultValue: 1
						},
						{
							heading: 'C<sub>SS</sub>',
							unit: UNITS_SIGN.NANO_FARAD,
							netlistUnit: 'n',
							mappingName: 'Css',
							minBoundary: 0.1,
							maxBoundary: 1000,
							defaultValue: 470
						},
						{
							heading: 'ESR<sub>C<sub>SS</sub></sub>',
							unit: UNITS_SIGN.MILLI_OHM,
							netlistUnit: 'm',
							mappingName: 'EsrCss',
							minBoundary: 0,
							maxBoundary: 100,
							defaultValue: 1
						},
						{
							heading: 't<sub>ambient<sub>',
							unit: UNITS_SIGN.CELSIUS,
							netlistUnit: '',
							mappingName: 'Tset',
							minBoundary: -40,
							maxBoundary: 125,
							defaultValue: 25,
							displayInput: true
						}
					],
					schematic: {
						schematicPath: this.SCHEMATIC_TRAN
					},
					charts: [
						{
							id: 'ComposedChart',
							mainHeading: 'Timing Diagram',
							chartType: CHART_TYPE.COMPOSITE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'Voltage',
									unit: UNITS_SIGN.VOLT
									/*columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_IN
									 */
								}
							],
							composedCharts: [
								{
									id: 'VinVsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]IN[/] @ R[baseline-shift: sub; font-size: 11px;]OUT[/] = '
								},
								{
									id: 'VenVsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]EN[/] @ R[baseline-shift: sub; font-size: 11px;]OUT[/] = '
								},
								{
									id: 'VpgVsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]PG[/] @ R[baseline-shift: sub; font-size: 11px;]OUT[/] = '
								},
								{
									id: 'VbiasVsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]BIAS[/] @ R[baseline-shift: sub; font-size: 11px;]OUT[/] = '
								},
								{
									id: 'VoutVsTime',
									seriesLabel:
										'V[baseline-shift: sub; font-size: 11px;]OUT[/] @ R[baseline-shift: sub; font-size: 11px;]OUT[/] = '
								}
							],
							series: {
								heading: 'Voltage dependence',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'VinVsTime',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]IN[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]IN[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_IN
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'VenVsTime',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]EN[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]EN[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_EN
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'VpgVsTime',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]PG[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]PG[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_PG
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'VbiasVsTime',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]BIAS[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]BIAS[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_BIAS
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'VoutVsTime',
							mainHeading: 'V[baseline-shift: sub; font-size: 11px;]OUT[/] = f (t)',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: false,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'V[baseline-shift: sub; font-size: 11px;]OUT[/]',
									unit: UNITS_SIGN.VOLT,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.V_OUT
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'IoutVsTime',
							mainHeading:
								'I[baseline-shift: sub; font-size: 11px;]OUT[/] = f (t, R[baseline-shift: sub;font-size: 11px;]OUT[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]OUT[/]',
									unit: UNITS_SIGN.AMPER,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.I_OUT
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						},
						{
							id: 'IgndVsTime',
							mainHeading:
								'I[baseline-shift: sub; font-size: 11px;]GND[/] = f (t, R[baseline-shift: sub;font-size: 11px;]OUT[/])',
							chartType: CHART_TYPE.LINE_CHART,
							simulationType: SIMULATION_TYPE.TRANSIENT,
							visible: true,
							axis: [
								{
									id: ID_GRAPH_AXIS.X,
									heading: 'time',
									unit: UNITS_SIGN.SECOND,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.TIME
								},
								{
									id: ID_GRAPH_AXIS.Y1,
									heading: 'I[baseline-shift: sub; font-size: 11px;]GND[/]',
									unit: UNITS_SIGN.AMPER,
									columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.I_GND
								}
							],
							series: {
								heading: 'R[baseline-shift: sub;font-size: 11px;]OUT[/]',
								unit: UNITS_SIGN.OHM,
								columnNumber: TRANSIENT_CHART_COLUMN_MAPPING.R_LOAD
							}
						}
					]
				}
			]
		};

		return super.gainDefinition(customizations);
	}
}
